export default "__VITE_ASSET__Dyx2W1Av__"